import { FilterOperator } from '../../../../types/filter';
export const filterOperatorList = (...operators) => operators.join('/');
export const valuePresenceOperatorDescription = `Use ${FilterOperator.NULL} for missing values, ${FilterOperator.NOT_NULL} for present values.`;
export const datePresenceOperatorDescription = `Use ${FilterOperator.NULL} for missing dates, ${FilterOperator.NOT_NULL} for present dates.`;
//# sourceMappingURL=filterDescriptionUtils.js.map